import { GenericObjectArrayType } from "../types/common";
export const CONST_CREDENTIALS_KEY = "DGD^#&#^#*#&#*(^GDGE#^*&*%%%";
export const ORIGIN = "https://onepayx.net";

export const colors = {
  THEME_COLOR: "#364174",
  BUTTON: "#009a44",
  WHITE: "#ffffff",
};

export const STATUS_COLORS: Record<string, string> = {
  SUCCESSFUL: "green",
  POSTED: "#c0cdd8",
  PENDING: "gray",
  FAILED: "red",
};
export const CHANNEL_COLORS: Record<string, string> = {
  "App/Web Payment": "#4A90D9",
  "API Payment": "#7B68EE",
  "MerchantCode Payment": "#50C878",
  "QRCode Payment": "#FFB347",
  // add your channels...
};

export const PARTNER_COLORS: Record<string, string> = {
  MTN_DEPOSITS: "#4A90D9",
  AIRTEL_DEPOSITS: "#7B68EE",
};
export const IDLE_TIMEOUT = 20 * 60 * 1000; // 20 minutes
export const IDLE_WARNING_TIME = 1 * 60 * 1000; // 1 minute before timeout

export const BOOLEAN_OPTIONS: GenericObjectArrayType[] = [
  { id: 0, name: "False" },
  { id: 1, name: "True" },
];

export const BOOLEAN_SELECTIONS: GenericObjectArrayType[] = [
  { id: false, name: "No" },
  { id: true, name: "Yes" },
];

export const GENDER_SELECTIONS: GenericObjectArrayType[] = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
];

export const PAYMENT_METHODS: GenericObjectArrayType[] = [
  { id: "cash", name: "Cash" },
  { id: "cheque", name: "Cheque" },
  { id: "yoya_pay", name: "OnePayX" },
  { id: "bank_transfer", name: "Bank Transfer" },
  { id: "mobile_money", name: "Mobile Money" },
  { id: "credit_card", name: "Credit Card" },
];

export const FEW_PAYMENT_METHODS: GenericObjectArrayType[] = [
  { id: "mtn_momo", name: "MTN Momo" },
  { id: "airtel_pay", name: "Airtel Pay" },
  { id: "stanbic_bank", name: "Stanbic Bank" },
];

export const BENEFICIARY_TYPES: GenericObjectArrayType[] = [
  { id: "BANK", name: "Bank" },
  { id: "TELECOM", name: "Telecom" },
  { id: "MERCHANT", name: "Merchant" },
  { id: "UTILITY", name: "Utility" },
  { id: "LGA", name: "Local Government Authority" },
  { id: "INSTITUTION", name: "Institution" },
  { id: "OTHER", name: "Other" },
];

export const SETTLEMENT_TIMING: GenericObjectArrayType[] = [
  { id: "T0", name: "T+0" },
  { id: "T1", name: "T+1" },
  { id: "TN", name: "T+N" },
];

export const MALE = "Male";
export const FEMALE = "Female";

export const WEB_CHANNEL = "WEB";

// Document type
export const DOC_TYPE_REPORT = "report";
export const DOC_TYPE_OTHER = "other";
export const DOC_TYPE_ATTACHMENT = "attachment";

// DATE FORMATS
export const DATE_FORMAT = "DD-MM-YYYY";
export const DATE_YEAR = "YYYY";
export const DATE_TIME_FORMAT = "DD-MM-YYYY, hh:mm A";

// STATUS
export const PENDING = "pending";
export const SUBMITTED = "submitted";
export const RECOMMENDED_FOR_APPROVAL = "recommended_for_approval";
export const REJECTED = "rejected";
export const DELIVERED = "delivered";
export const APPROVED = "approved";
export const DEFERRED = "deferred";
export const FOWARDED = "fowarded";
export const DISBURSED = "disbursed";
export const CLOSED = "closed";
export const DRAFT = "draft";
export const PENDING_APPROVAL = "pending_approval";
export const SENT_TO_BANK = "sent_to_bank";
export const SETTLED = "settled";
export const FAILED = "failed";
export const POSTED = "posted";

// LABELS
export const VIEW = "View";
export const EDIT = "Edit";
export const ASSIGN = "Assign";
export const DELETE = "Delete";
export const VERIFY = "Verify";
export const DEACTIVATE = "Deactivate";
export const ACTIVATE = "Activate";
export const APPROVE = "Approve";
export const SUSPEND = "Suspend";
export const BLOCK = "Block";
export const REACTIVATE = "Reactivate";
export const CLOSE = "Close";
export const REJECT = "Reject";
export const RESOLVE = "Resolve";
export const RESOLVED = "resolved";
export const EXECUTE = "Execute";
export const RETRY = "Retry";
export const SUBMIT = "Submit For Approval";
export const SEND_TO_FM = "Send to Finance Manager";
export const MARK_TRANSACTION_AS_PENDING = "Mark As Pending";
export const REJECT_REVERSAL = "Reject Reversal";
export const COMPLETE_REVERSAL = "Complete Reversal";

// source IDs
export const ASSIGN_TO_COA = "assign_to_coa";

// MASTER DATA TYPES
export const DISTRICT = "district";
export const PARISH = "parish";
export const COUNTY = "county";
export const SUB_COUNTY = "sub_county";
export const VILLAGE = "village";

//Plurals
export const DISTRICTS = "districts";
export const COUNTIES = "counties";
export const SUB_COUNTIES = "sub_counties";
export const PARISHES = "parishes";
export const VILLAGES = "villages";

// PROFILE
export const PROFILE = "profile";
export const USERS = "users";
export const ADMIN = "ADMIN";
export const AGENT = "AGENT";
export const MERCHANT = "MERCHANT";
export const ACCOUNTANT = "ACCOUNTANT";
export const STAFF = "STAFF";

// Permissions
export const CAN_VIEW_SYSTEM_SETTINGS = "can_view_system_settings";
export const CAN_EDIT_SYSTEM_SETTINGS = "can_edit_system_settings";
export const CAN_EDIT_USERS = "can_edit_users";
export const CAN_ADD_LOAN_USER = "add_yoyaloanuser";
export const CAN_CHANGE_LOAN_USER = "change_yoyaloanuser";
export const CAN_DELETE_LOAN_USER = "delete_yoyaloanuser";
export const CAN_VIEW_LOAN_USER = "view_yoyaloanuser";
export const CAN_VIEW_REPORTS = "can_view_reports";
export const CAN_PUBLIC = "can_public";
export const CAN_MANAGE_CHARTS_OF_ACCOUNTS = "can_manage_chart_of_accounts";
export const CAN_ADMIN = "can_admin";
export const CAN_MERCHANT = "can_merchant";
export const CAN_AGENT = "can_agent";
export const CAN_CREATE_FEES = "can_create_fees";

// Application permissions
export const CAN_VIEW_SUBMITTED_APPLICATIONS =
  "can_view_submitted_applications";
export const CAN_VIEW_APPROVED_APPLICATIONS = "can_view_approved_applications";
export const CAN_VIEW_RECOMMENDED_APPLICATIONS =
  "can_view_recommended_applications";
export const CAN_APPROVE_APPLICATION = "can_approve_application";
export const CAN_REJECT_APPLICATION = "can_reject_application";
export const CAN_DEFER_APPLICATION = "can_defer_application";
export const CAN_RECOMMEND_APPLICATION = "can_recommend_application";
export const CAN_REVIEW_APPLICATION = "can_review_application";
export const CAN_ADD_APPLICATION = "can_add_application";
export const CAN_SPECIAL_EDIT = "can_special_edit";
export const CAN_MAKE_PAYMENTS = "can_make_payments";

// Organisation permissions
export const CAN_ADD_ORGANISATION = "can_add_organisation";

// Payroll permissions
export const CAN_CREATE_PAYROLL = "can_process_payroll";
export const CAN_REVIEW_PAYROLL = "can_review_payroll";
export const CAN_APPROVE_PAYROLL = "can_approve_payroll";
export const CAN_ACCESS_PAYROLL_MODULE = "can_access_payroll_module";
export const CAN_EDIT_PAYROLL = "can_update_payroll_data";
export const CAN_ADD_INVENTORY_CHECKLIST = "can_add_inventory_checklist";

// inventory permissions
export const CAN_SUBMIT_PURCHASE_ORDER = "can_submit_purchase_order";
export const CAN_VIEW_PURCHASE_ORDER = "can_view_submitted_register";
export const CAN_APPROVE_PURCHASE_ORDER = "can_approve_purchase_order";
export const CAN_EDIT_PURCHASE_ORDER = "can_review_submitted_purchase_order";
export const CAN_VIEW_SUBMITTED_REGISTER = "can_view_submitted_register";
export const CAN_SUBMIT_RECEIVE_INVENTORY_CHECKLIST =
  "can_submit_receive_inventory_checklist";
export const CAN_EDIT_RECEIVED_INVENTORY_CHECKLIST =
  "can_review_received_inventory_checklist";

// Purchase order permissions
export const CAN_ADD_PRODUCT_TO_PURCHASE_ORDERS = "can_add_product_to_orders";

export const APPLICATIONS_ACTIONS = [
  CAN_APPROVE_APPLICATION,
  CAN_REJECT_APPLICATION,
  CAN_RECOMMEND_APPLICATION,
  CAN_REVIEW_APPLICATION,
];

// TYPES
export const SELECT = "select";
export const MODAL = "modal";
export const TEXT = "text";

// Loan application types
export const NEW_APPLICANT = "New Applicant";
export const EXISTING_APPLICANT = "Existing Applicant";
export const MIGRATED_APPLICANT = "Migrated Applicant";
export const RESTRUCTURED_APPLICANT = "Restructured Applicant";

// SOURCES
export const LOAN_APPLICATION = "loan_application";

export const FORM_DATA = "multipart/form-data";

// CONFIGURABLES
export const MOTORCYCLE_TYPE = "motorcycle-type";
export const VEHICLE_TYPE = "vehicle-type";
export const CATEGORY_INVENTORY_TYPE = "inventory-category";
export const INCOME_TYPE = "income-type";
export const EXPENSE_TYPE = "expense-type";
// FILE EXTENSIONS
export const FILE_TYPE_DOC = "doc";
export const FILE_TYPE_DOCX = "docx";
export const FILE_TYPE_JPG = "jpg";
export const FILE_TYPE_JPEG = "jpeg";
export const FILE_TYPE_PNG = "png";
export const FILE_TYPE_PDF = "pdf";

// data view
export const DEFAULT_EXCLUDED = [
  "id",
  "declaration",
  "created_at",
  "updated_at",
  "deleted",
];

// Salary component
export const BASE_SALARY = "base_salary";
export const ALLOWANCE = "allowance";
export const BONUS = "bonus";

// Adhoc Reports
const TODAY = "today";
const YESTERDAY = "yesterday";
const THIS_WEEK = "this_week";
const LAST_WEEK = "last_week";
const THIS_MONTH = "this_month";
const LAST_MONTH = "last_month";
const THIS_YEAR = "this_year";
const LAST_YEAR = "last_year";
const THIS_FY = "this_fy";
const LAST_FY = "last_fy";

export const START_DATE_FILTER = "created_at_min_date";
export const END_DATE_FILTER = "created_at_max_date";

export const preFilters = [
  TODAY,
  YESTERDAY,
  THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  THIS_YEAR,
  LAST_YEAR,
  THIS_FY,
  LAST_FY,
];

export const INVOICES_REPORT_ADHOC = "invoices_reports";
export const CHART_OF_ACCOUNTS_ADHOC = "chart-of-accounts";
export const TRANSACTIONS_LIST_ADHOC = "transactions-list";

export const CONST_PAYMENTS = "payments";
export const LOAN_APPLICATIONS = "loan-applications";
export const PURCHASE_ORDERS = "purchase-orders";
export const AGING_REPORT = "debtors_aging_report";
export const AGING_REPORT_ADHOC_API = "reports/debtors-ageing-report-adhoc/";
export const LEDGER_REPORT_ADHOC_API = "accountings/ledgers-adhoc/";
export const LOAN_REPAYMENTS = "loan-repayments";
export const LEDGER_REPORT = "ledger-report";
export const CHART_OF_ACCOUNTS_ADHOC_API = "reports/chart-of-accounts-adhoc/";
export const TRANSACTION_LIST_ADHOC_API = "reports/transaction-list-adhoc/";

export const CONST_MODULES = [
  // { value: CONST_PAYMENTS, label: "Payments" },
  // { value: LOAN_REPAYMENTS, label: "Loan Repayments" },
  // {
  //   value: LOAN_APPLICATIONS,
  //   label: "Loan Applications",
  // },
  // {
  //   value: PURCHASE_ORDERS,
  //   label: "Purchase Orders",
  // },
  // {
  //   value: AGEING_REPORT,
  //   label: "Debtors Ageing Report",
  // },
  // {
  //   value: LEDGER_REPORT,
  //   label: "Ledger Report",
  // },
  {
    value: CHART_OF_ACCOUNTS_ADHOC,
    label: "Chart of Accounts",
    api: `/chart-of-accounts-adhoc-report/`,
  },
  {
    value: TRANSACTIONS_LIST_ADHOC,
    label: "Transactions List",
    api: `/transaction-list-adhoc-report/`,
  },
];

export const APP_NAME = "OnePayX";
export const APP_ORGANIZATION = "OnePayX";
// export const APP_NAME = "OnePayX Loans";

export const CUSTOMER_REPORT_REQUESTS = "customer_report_requests";

// WALLET TRANSFERS
export const WALLET_TRANSFERS = "wallet_deposit";

// PAYMENT ITEMS
export const WALLET_TRANSFER = "WALLET TRANSFERS";
export const URA_PAYMENTS = "URA PAYMENTS";

//FLOAT MANAGEMENT
export const CREDIT_HOLDINGS = "CREDIT_HOLDINGS";
export const DEBIT_HOLDINGS = "DEBIT_HOLDINGS";
export const REVERSE_TRANSACTION = "REVERSE_TRANSACTION";
export const LIQUIDATIONS = "LIQUIDATIONS";
export const REPLENISHMENT = "REPLENISHMENT";

// FRAUD DETECTION
export const FRAUD_CASES = "fraud_cases";
export const FRAUD_WEIGHTSCORE = "FRAUD_WEIGHT_SCORE";
